/**
 * Format time to string for countdown
 * @param {number} seconds 
 * @returns formatted MM:SS
 */
export function formatTime(seconds) {
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
}